// extracted by mini-css-extract-plugin
export default {"list":"tend-to-overthink_list__n7zUS","arrow_icon":"tend-to-overthink_arrow_icon__WCuMg"};